import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  Paper,
  Tabs,
  Tab,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import TabPanel from "../../../component/TabPanel";
import {
  deletePartner,
  getPartnerById,
  updatePartner,
} from "../../../api/partnerList";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";
import DeleteAlertDialog from "../../../component/DeleteAlertDialog";
import DeleteDialog from "../../../component/DeleteDialogDetailPage";

const emptyPartnerDetailData = {
  name: "",
  email: "",
  password: "",
  contact: "",
  address: "",
  city: "",
  state: "",
  country: "",
  role: "",
};
export default function ViewPartners() {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);
  const [open, setOpen] = useState(false);
  const [partnerDetailData, setPartnerDetailData] = useState(
    emptyPartnerDetailData
  );
  useEffect(() => {
    if (!params.id) {
    } else {
      loadMasterData();
    }
  }, [params.id]);
  async function loadMasterData() {
    try {
      const { data } = await getPartnerById(params.id, user.token);
      setPartnerDetailData(data.data.partner);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function onPartnerUpdate() {
    const combineData = {
      name: partnerDetailData.name,
      email: partnerDetailData.email,
      password: partnerDetailData.password,
      contact: partnerDetailData.contact,
      address: partnerDetailData.address,
      city: partnerDetailData.city,
      state: partnerDetailData.state,
      country: partnerDetailData.country,
      role: partnerDetailData.role,
    };
    try {
      const { data } = await updatePartner(params.id, combineData, user.token);
      loadMasterData();
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }
  const onInputChange = (e) => {
    setPartnerDetailData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };
  const onDelete = () => {
    deletePartner(params.id, user.token)
      .then((res) => {
        if (res.data.status == true) {
          navigate("/partners");
          dispatch(showAlert(res.data.msg));
        } else {
          dispatch(showAlert(res.data.msg));
        }
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };
  return (
    <Box sx={{ flexGrow: 1}}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        ></Box>
        <Grid container spacing={2} sx={{ pt: "1rem" }}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="name"
              label="Name"
              className="name-textfeild"
              value={partnerDetailData.name || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="email"
              label="Email"
              value={partnerDetailData.email || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="contact"
              label="Contact"
              value={partnerDetailData.contact || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="address"
              label="Address"
              value={partnerDetailData.address || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="state"
              label="State"
              value={partnerDetailData.state || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="country"
              label="Country"
              value={partnerDetailData.country || ""}
              onChange={onInputChange}
              fullWidth
              variant="outlined"
              type="text"
            />
          </Grid>

          <Grid item xs={12}>
            {
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  variant="contained"
                  onClick={onPartnerUpdate}
                  style={{ padding: "5px 7px" }}
                  className="blue-button"
                >
                  Update
                </Button>
                {/* <Button
                  variant="contained"
                  onClick={() => {
                    setOpen(true);
                  }}
                  style={{ padding: "5px 7px" }}
                >
                  Delete
                </Button> */}
              </Box>
            }
          </Grid>
        </Grid>
      </Paper>
      <br />
      <DeleteDialog open={open} setOpen={setOpen} onDelete={onDelete} />
    </Box>
  );
}
